import React from 'react'

export default function Header() {
  return (
    <div id='main'>
      <div className="header-heading">
        <h2>STEP UP YOUR</h2>
        <h1><span>FITNESS</span>WITH US</h1>
        <p className="details">Lets become healthy,Lets live with joy,By Making Us your Choice</p>
        <div className="header-btns">
            <a href="/" className="header-btn">Join Us</a>
        </div>
      </div>
    </div>
  )
}
